export default {
  fields: {
    cc_auth: {
      readOnly: true
    } 
  }
}
